import { jsx as _jsx } from "react/jsx-runtime";
import { Collapsible } from "../../collapsible";
import { BlockField } from "../";
export const BlockCollapsible = ({ children, onCatch, }) => (_jsx("div", { style: { marginBottom: "30px" }, children: _jsx(Collapsible, { openTitle: "Read more", closeTitle: "Read less", buttonSize: "large", splitIndex: 0, children: children.map(block => (_jsx(BlockField, { block: block, onCatch: onCatch }, block.id))) }) }));
